<template>
  <div class="px-8 py-8 pb-0">
    <p>If you choose to stay covered you will benefit from:</p>
    <ul class="pa-0">
      <li
        v-for="(renew, index) in cardConfigs.autoRenew"
        class="d-flex"
        :key="index"
      >
        <span class="mr-3"
          ><v-icon color="accent">mdi-checkbox-marked-circle</v-icon></span
        >
        <div>
          <p class="font-weight-bold ma-0 mb-1">
            {{ renew.title }}
          </p>
          <p class="font-14">
            {{ renew.description }}
          </p>
        </div>
      </li>
    </ul>
    <p class="mt-3">If you choose NOT to auto renew, please note:</p>
    <ul class="pa-0">
      <li
        v-for="(notAutoRenew, index) in cardConfigs.doNotAutoRenew"
        class="d-flex"
        :key="index"
      >
        <span class="mr-3"><v-icon>mdi-checkbox-marked-circle</v-icon></span>
        <div>
          <p class="font-weight-bold ma-0 mb-1">
            {{ notAutoRenew.title }}
          </p>
          <p class="font-14">
            {{ notAutoRenew.description }}
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { AUTO_RENEW, DO_NOT_AUTO_RENEW } from "@/constants/payment.constants";

export default {
  name: "DialogContentAutoRenewalInfoMobile",
  props: {
    cardConfigs: {
      type: Object,
      default: () => ({
        autoRenew: AUTO_RENEW,
        doNotAutoRenew: DO_NOT_AUTO_RENEW,
      }),
    },
  },
};
</script>

<style lang="scss" scoped></style>
